import React from 'react';
import { graphql } from "react-apollo";

import { mails } from '../../graphql/queries';

import ListItem from '../ListItem'
import { ColHead, ColError, ColLoading } from '../chunk'
import MailDeleteAll from './MailDeleteAll';
import Divider from '../../atoms/Divider'
import { formatDateTime, passedTime } from '../../date3';

class MailList extends React.Component {

	constructor(props) {
		super(props);
    }

    deleteAll() {
        const confirm = window.confirm('This cannot be undone, y\'know?');
        if(!confirm) return;
    }

	render() {

        return (
            <div className="col col-2">{(() => {

                let {loading, error, mails, refetch} = this.props.data;
                if( loading ) return (<ColLoading />);
                if (error) return (<ColError error={error} />);

                console.log(mails);

                return (
                    <React.Fragment>
                        <div className="col__actions">
                            <button className="col__action" onClick={() => refetch()}>Refresh</button>
                            {(mails.length > 0) && <MailDeleteAll />}
                        </div>
                        <ColHead icon="inbox" title="MAIL INBOX" meta={`${mails.length} Mails`} />

                        <div className="list">
                            {(mails.length > 0) ? mails.map((mail) => (
                                <ListItem key={mail.id} url={`/mails/${mail.id}`}>
                                    <div className="truncate">
                                        {mail.subject}<br />
                                        <span className="list__meta">{mail.from}</span>
                                        <span className="list__meta"
                                            title={formatDateTime(mail.dateSent)}
                                            > / {passedTime(mail.dateSent)}
                                        </span>
                                    </div>
                                    {mail.unread && <div className="unread unread--dot"></div>}
                                </ListItem>
                            )) : <Divider label="your inbox is empty" />}
                        </div>
                    </React.Fragment>
                )

            })()}</div>
        );
	}
}


export default graphql(mails)(MailList)


// WEBPACK FOOTER //
// ./src/components/mail/MailList.js